/**
 * AddToCart – Global handler (safe for quick-add buttons)
 * SKIPS forms with data-skip-global-cart="true"
 */

class AddToCart {
  static async addToCart(formData) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.description || 'Network error');
      }

      const item = await response.json();

      // Notify cart manager (used by simple-cart.js)
      window.dispatchEvent(new CustomEvent('product:added', {
        detail: { item }
      }));

      // Open cart drawer
      const cartToggle = document.querySelector('[data-drawer-toggle="cart"]');
      if (cartToggle) {
        cartToggle.click();
      }

      return { success: true, item };
    } catch (error) {
      console.error('AddToCart: Failed to add item:', error);
      return { success: false, error: error.message };
    }
  }

  static async handleSubmit(event, button) {
    // --- CRITICAL: Skip if form is handled by product.js ---
    const form = event.target.tagName === 'FORM' ? event.target : null;
    if (form && form.dataset.skipGlobalCart === 'true') {
      console.log('AddToCart: Skipping form (handled by product.js)');
      return; // Let product.js handle it
    }

    event.preventDefault();

    const originalHTML = button.innerHTML;
    button.innerHTML = '<span class="loading-spinner"></span> Adding...';
    button.disabled = true;

    let formData;
    if (form) {
      formData = new FormData(form);
    } else {
      // Fallback for buttons with data-variant-id
      formData = new FormData();
      formData.append('id', button.dataset.variantId);
      formData.append('quantity', 1);
    }

    const result = await this.addToCart(formData);

    if (result.success) {
      button.innerHTML = 'Added';
    } else {
      button.innerHTML = 'Error';
    }

    // Restore original button text after 2 seconds
    setTimeout(() => {
      button.innerHTML = originalHTML;
      button.disabled = false;
    }, 2000);
  }
}

// Attach to window for use in inline onclick or other scripts
window.AddToCart = AddToCart;

// Optional: Auto-bind to any form with class "add-to-cart-form"
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('form.add-to-cart-form').forEach(form => {
    form.addEventListener('submit', (e) => {
      const button = form.querySelector('button[type="submit"]') || e.submitter;
      if (button) AddToCart.handleSubmit(e, button);
    });
  });
});
